import { Reveal } from "./Reveal";
import { ArchWindow } from "./ArchWindow";

export const AboutLuke = () => (
  <section id="about" className="py-28 md:py-36 relative">
    <div className="max-w-7xl mx-auto px-6 lg:px-10 grid lg:grid-cols-[0.8fr_1.2fr] gap-16 items-center">
      <Reveal>
        <div className="relative flex justify-center">
          <div className="arch-shape overflow-hidden w-[300px] h-[430px] border border-[#120716]/10" style={{ boxShadow: "0 16px 60px rgba(232,76,76,0.25)" }}>
            <img
              src="/images/luke-adams.jpg"
              alt="Luke Adams, Founder & CEO of Digital Missions"
              className="w-full h-full object-cover"
              style={{ objectPosition: "58% 50%" }}
              data-testid="about-luke-photo"
            />
          </div>
          <div className="absolute -bottom-5 left-1/2 -translate-x-1/2 glass rounded-full px-6 py-2 whitespace-nowrap">
            <span className="font-orbitron text-xs tracking-widest text-[#120716]">LUKE ADAMS · FOUNDER & CEO</span>
          </div>
        </div>
      </Reveal>
      <Reveal delay={0.15}>
        <div className="flex items-center gap-3">
          <ArchWindow size={14} />
          <span className="font-orbitron text-xs tracking-[0.4em] text-[#E84C4C]">MY STORY</span>
        </div>
        <h2 className="font-orbitron font-bold text-2xl sm:text-3xl lg:text-4xl text-[#120716] mt-4 leading-tight">
          A WORD FROM LUKE
        </h2>
        <p className="mt-6 text-[#120716]/70 leading-relaxed text-sm md:text-base max-w-xl" data-testid="about-story-1">
          I'm a web developer and marketer. For years I built for clients who could pay, and I was
          good at it. Then I started noticing the churches: faithful congregations with a message the
          world desperately needs and a website that hadn't been touched in a decade, if one existed
          at all. Once I saw it, I couldn't unsee it.
        </p>
        <p className="mt-5 text-[#120716]/70 leading-relaxed text-sm md:text-base max-w-xl" data-testid="about-story-2">
          Digital Missions is my answer. I take the skills I would otherwise sell and I give them to
          churches, free of charge, sustained by donors who believe what I believe: that the internet
          is today's Roman road, and the Gospel should travel it well. The message hasn't changed in
          two thousand years. I just want to make sure it can be found.
        </p>
        <blockquote className="mt-8 border-l-2 border-[#E84C4C] pl-5 italic font-light text-[#C13B3B]">
          "Whatever you do, work heartily, as for the Lord and not for men."
          <cite className="block mt-2 not-italic font-orbitron text-xs tracking-widest text-[#E84C4C]/70">COLOSSIANS 3:23</cite>
        </blockquote>
        <div className="mt-10 flex flex-wrap gap-4" data-testid="about-values">
          {["SERVE", "CONNECT", "EMPOWER", "MULTIPLY"].map((v) => (
            <div key={v} className="flex items-center gap-2 rounded-full border border-[#120716]/15 px-5 py-2">
              <ArchWindow size={12} />
              <span className="font-orbitron text-xs tracking-widest text-[#120716]">{v}</span>
            </div>
          ))}
        </div>
      </Reveal>
    </div>
  </section>
);
